import {asField} from "../lib/mobx-form";

function Hidden() {
  return null;
}

export default asField(Hidden);
